/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import LazyImage from 'gatsby-core-theme/src/hooks/lazy-image';
import getTeamLogo from '../../../helpers/common.js';
import styles from './featured-match.module.scss';

// eslint-disable-next-line react/prop-types
const DefImg = (alt = '') => (
  <img src="../../../../images/default.svg" alt={alt} width={23} height={23} />
);

const FeaturedMatch = ({ item, context }) => (
  <div className={`${styles.container} ${styles[context]}`}>
    <div className={styles.teamLogos}>
      <div className={styles.teams}>
        <div className={styles.logo}>
          <LazyImage
            alt={item?.home_team?.name}
            src={getTeamLogo(item?.home_team)}
            width={23}
            height={23}
            defaultImg={<DefImg alt={item?.home_team?.name} />}
          />
        </div>
        <span>vs</span>
        <div className={styles.logo}>
          <LazyImage
            alt={item?.away_team?.name}
            src={getTeamLogo(item?.away_team)}
            width={23}
            height={23}
            defaultImg={<DefImg alt={item?.home_team?.name} />}
          />
        </div>
      </div>
    </div>
    <div className={styles.teamNames}>
      <span>{item?.home_team?.name}</span>
      <span>{item?.away_team?.name}</span>
    </div>
  </div>
);

export default FeaturedMatch;

FeaturedMatch.propTypes = {
  item: PropTypes.shape({
    home_team: PropTypes.shape({
      name: PropTypes.string,
      logo: PropTypes.string,
    }),
    away_team: PropTypes.shape({
      name: PropTypes.string,
      logo: PropTypes.string,
    }),
    date: PropTypes.shape({
      day_number: PropTypes.number,
      month_short: PropTypes.string,
      year_number: PropTypes.number,
      time: PropTypes.string,
    }),
  }).isRequired,
  context: PropTypes.oneOf(['header', 'cards', 'content']),
};
